import { CancelTokenSource } from "axios";
import { GetterTree } from "vuex";
import { RefreshGridMode } from "@/models/leads/Lead";
import { DataSourceResult } from "@/models/DataSourceResult";
import { FilterCollection } from "@/models/FilterCollection";
import { GridColumn } from "@/models/GridColumn";
import { MetadataMaskyooStatus } from "@/models/MetadataMaskyooStatus";
import { ChannelMultiselectItem, MultiselectItem } from "@/models/MultiselectItem";
import { PhoneStatus, PhoneWithChannel } from "@/models/phones/PhoneWithChannel";
import { TableSettings } from "@/models/TableSettings";
import { PhoneLeadStats } from "@/models/leads/LeadStatistic";
import { PhonesPageData } from "@/models/phones/PhonesPageData";import { PhonesState } from "@/models/states/PhonesState";
import { RootState } from "@/models/states/RootState";

const getters: GetterTree<PhonesState, RootState> = {
  cancelTokenSource(state): CancelTokenSource | undefined {
    return state.cancelTokenSource;
  },

  channels(state): ChannelMultiselectItem[] {
    return state.channels;
  },
  
  companies(state): MultiselectItem[] {
    return state.companies;
  },

  columns(state): GridColumn[] {
    return state.columns;
  },

  columnsFilters(state): FilterCollection | undefined {
    return state.columnsFilters;
  },

  datePeriod(state): Date[] {
    return state.datePeriod;
  },
  
  needToRefreshPhonesGrid(state): RefreshGridMode {
    return state.needToRefreshPhonesGrid;
  },

  page(state): number {
    return state.page;
  },

  phoneLeadStats(state): PhoneLeadStats | undefined {
    return state.phoneLeadStats;
  },

  phones(state): DataSourceResult {
    return state.phones;
  },

  phonesPageData(state): PhonesPageData {
    return state.phonesPageData;
  },

  searchValue(state): string {
    return state.searchValue;
  },

  selectedCallStatus(state): MetadataMaskyooStatus | undefined {
    return state.selectedCallStatus;
  },

  selectedChannelMetadataTypesIds(state): number[] {
    return state.selectedChannelMetadataTypesIds;
  },

  selectedCompaniesIds(state): number[] {
    return state.selectedCompaniesIds;
  },

  selectedPhone(state): PhoneWithChannel | undefined {
    return state.selectedPhone;
  },

  selectedPhonesGridColumnsIds(state): number[] {
    return state.selectedPhonesGridColumnsIds;
  },

  selectedPhoneStatus(state): PhoneStatus | undefined {
    return state.selectedPhoneStatus;
  },

  selectedSourcesIds(state): string[] {
    return state.selectedSourcesIds;
  },

  showGraphs(state): boolean {
    return state.showGraphs;
  },

  sortDir(state): string {
    return state.sortDir;
  },

  sortField(state): string {
    return state.sortField;
  },

  sources(state): ChannelMultiselectItem[] {
    return state.sources;
  },

  tableSettings(state): TableSettings | undefined {
    return state.tableSettings;
  },
};
export default getters;
